export default {
    settingStatementStrategy: {
      header: {
        channel: '渠道',
        name: '策略名称',
      },
      strategy: '新增策略',

      table: {
        sale: '销售渠道',
        name: '策略名称',
        type: '账单类型',
        field: '取值字段',
        keywords: '匹配关键字',
        amount: '金额取值',
        orderNumber: '订单号取值',
        refundForm: '退款单号取值',
      },

      addAndEdit: {
        editTitle: '编辑平台账单策略',
        addTitle: '新增平台账单策略',
        name: '策略名称',
        namePlaceholder: '请输入策略名称',
        type: '账单类型',
        sale: '销售收入',
        return: '退款支出',
        channel: '渠道',
        channelPlaceholder: '请选择渠道',
        field: '取值字段',
        fieldText: '请选择取值字段',
        keywords: '匹配关键字',
        keywordsPlaceholder: '请输入匹配关键字',
        orderNumber: '订单号取值',
        orderNumberText: '请选择订单号取值',
        amount: '金额取值',
        fixedField: '取固定字段',
        calculate: '按公式计算',
        fieldPlaceholder: '请选择字段',
        rulesType: '请选择账单类型',
        refundNoField: '请选择退款单号取值',
        amountType: '请选择金额取值',
        enabledFlag: '请选择状态',
        filterKeyword: '支持多个，以|隔开',
        fieldTitle: '字段',
        addField: '增加字段',
        calculationRules: '计算规则'
      }
    },
};
